import { render } from "./408.vue?vue&type=template&id=6cb2ee46&scoped=true"
const script = {}

import "./408.vue?vue&type=style&index=0&id=6cb2ee46&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6cb2ee46"

export default script